import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import autofit from 'autofit.js'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import SocketService from '@/utils/websocket';
import { initExamExperience } from '@/utils/examExperience'; // 在根应用安装受控任务恢复及全局导航保护。

Vue.use(ElementUI);
// 这里的地址可以根据环境变动（生产/开发）
const wsUrl = process.env.VUE_APP_WS_URL || 'wss://sk.hzaqjk.com/wss';
const socket = new SocketService(wsUrl);

// 挂载到全局
Vue.prototype.$socket = socket;

initExamExperience(router, socket); // 先安装监听和守卫，避免连接消息早于页面监听。

// 立即连接
socket.connect();


Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: h => h(App),
    mounted() {
        // 保持你要求的全屏适配逻辑
        autofit.init({
            designHeight: 1080,
            designWidth: 1920,
            renderDom: "#app",
            resize: true,
        })
    }

}).$mount('#app')
